import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { LocalizationModule } from '../../Core/Localization/localization.module';
import { CommonFormsModule } from '../Forms/forms.module';


import { CoreDialogsModule } from '../../Core/Dialogs/dialogs.module';

import { MiscModule } from '../Misc/misc.module';
import { ManageContentLibraryDialogComponent } from './components/ManageContentLibraryDialog/manage-content-library-dialog.component';
import { CommonBasicModule } from '../Basic/basic.module';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { TooltipModule } from 'primeng/tooltip';
import { TakeOverModule } from '../TakeOver/take-over.module';
import { CommonDialogsModule } from '../Dialogs/common-dialogs.module';
import { FilterModule } from '../Filter/filter.module';
import { FilterService } from '../Filter/services/abstract-filter.service';
import { ContentLibraryItemComponent } from './components/ContentLibraryItem/content-library-item.component';
import { LibraryItemDetailsComponent } from './components/LibraryItemDetails/library-item-details.component';
import { ContentLibrarySearchService } from './services/content-library-search.service';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { TargetingSharedModule } from '../TargetingShared/targeting-shared.module';
import { MultipleItemSelectionComponent } from './components/mutipleItemSelection/multiple-item-selection.component';
import { ContentLibraryFolderApiService } from '../../api/contentLibrary/content-library-folder.api.service';
import { ContentLibraryMediaService } from './services/content-library-media.service';
import { ContentLibraryFolderService } from './services/content-library-folder.service';
import { ContentLibraryApi } from '../../api/contentLibrary/contentLibrary.api';
import { LayoutModule } from '../../Common/Layout/layout.module';
import { ContentLibraryPopupComponent } from './components/ContentLibraryPopup/content-library-popup.component';
@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        LocalizationModule,
        CommonFormsModule,
        CoreDialogsModule,
        MiscModule,
        CommonBasicModule,
        AutoCompleteModule,
        TooltipModule,
        TakeOverModule,
        CommonDialogsModule,
        ScrollingModule,
        FilterModule,
        TargetingSharedModule,
        LayoutModule
    ],
    declarations: [
        ManageContentLibraryDialogComponent,
        ContentLibraryItemComponent,
        LibraryItemDetailsComponent,
        MultipleItemSelectionComponent,
        ContentLibraryPopupComponent
    ],
    exports: [
        ManageContentLibraryDialogComponent,
        ContentLibraryItemComponent,
        LibraryItemDetailsComponent,
        MultipleItemSelectionComponent,
    ],
    providers: [
        { provide: FilterService, useExisting: ContentLibrarySearchService },
        ContentLibrarySearchService,
        ContentLibraryFolderApiService,
        ContentLibraryMediaService,
        ContentLibraryFolderService,
        ContentLibraryApi
    ]
})
export class ContentLibraryDialogModule  {}
